import type { ReactNode } from 'react';

export const symbol_line_end: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M790-390q-29.09 0-52.54-17Q714-424 705-450H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-510 110-510h595q9-26 32.46-43 23.45-17 52.54-17 37.8 0 63.9 26.14t26.1 64Q880-442 853.9-416T790-390Z"
		/>
	</svg>
);
